import type { CampaignConfigProviderCampaignFragment } from 'generated/graphql';
import type { CreativeNamePrefixOverrideFn, PublishingConfig } from '../../../campaign-configs/types';
import type { TContent, TFormValues } from '../types';
import { generateConfigDrivenFlavorCreativePublishInput } from './generate-flavor-creative-publish-input';
import { getConfigDrivenFormFilteredAssets } from './get-filtered-assets';

const creativeNamePrefixOverrides: Record<string, CreativeNamePrefixOverrideFn> = {
  events: () => 'EV_MULTI',
};

const getCreativeNamePrefixOverrideFromConfig = (config: CampaignConfigProviderCampaignFragment) =>
  config.publishing?.creativeNamePrefixOverrideKey
    ? creativeNamePrefixOverrides[config.publishing?.creativeNamePrefixOverrideKey]
    : undefined;

export const buildPublishingConfig = (config: CampaignConfigProviderCampaignFragment): PublishingConfig<TContent, TFormValues> => {
  return {
    campaignConfig: config,
    generateFlavorCreativePublishInput: generateConfigDrivenFlavorCreativePublishInput,
    getCreativeNamePrefixOverride: getCreativeNamePrefixOverrideFromConfig(config),
    getEligibilityCriteriaContainerId: (eligibilityCriteria) => {
      if (eligibilityCriteria.categoryNode?.length) return eligibilityCriteria.categoryNode;
      if (eligibilityCriteria.asins.length) return eligibilityCriteria.asins;
      if (eligibilityCriteria.browseNodes.length) return eligibilityCriteria.browseNodes;
      if (eligibilityCriteria.subscriptionProductPageIds?.length) return eligibilityCriteria.subscriptionProductPageIds;
    },
    // TODO: Add to config?
    getFilteredAssetsFn: getConfigDrivenFormFilteredAssets,
    includeAssetDimensions: false,
  };
};
